export default function AgGridHelpToolTip() {
}

AgGridHelpToolTip.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('ag-help-tooltip');
    this.eGui.style.backgroundColor = '#1C1F20'
    this.eGui.style.border = '1px solid #b5b5b5'

    this.eGui.innerHTML = `<table class="ag-grid-rule-tooltip">
                             <tr>
                               <th>EXPR</th>
                               <th>RULE</th>
                             </tr>
                             <tr>
                               <td>==</td>
                               <td>EQUAL</td>
                             </tr>
                             <tr>
                               <td>!=</td>
                               <td>NOT EQUAL</td>
                             </tr>
                             <tr>
                               <td>=gt=</td>
                               <td>GREATER THAN</td>
                             </tr>
                             <tr>
                               <td>=ge=</td>
                               <td>GREATER THAN OR EQUAL</td>
                             </tr>
                              <tr>
                               <td>=lt=</td>
                               <td>LESS THAN</td>
                             </tr>
                             <tr>
                               <td>=le=</td>
                               <td>LESS THAN OR EQUAL</td>
                             </tr>
                             <tr>
                               <td>=re=</td>
                               <td>LIKE REGEX</td>
                             </tr>
                             <tr>
                               <td>=nre=</td>
                               <td>NOT LIKE REGEX</td>
                             </tr>
                             <tr>
                               <td>=in=</td>
                               <td>CONTAINS</td>
                             </tr>
                             <tr>
                               <td>=iin=</td>
                               <td>CONTAINS IGNORE CASE</td>
                             </tr>
                             <tr>
                               <td>=out=</td>
                               <td>NOT CONTAINS</td>
                             </tr>
                             <tr>
                               <td>=iout=</td>
                               <td>NOT CONTAINS IGNORE CASE</td>
                             </tr>
                             <tr>
                               <td>phrase</td>
                               <td>CONTAINS</td>
                             </tr>
                           </table>
                            <div>
                                <p style="font-size: 13px; color: #b5b5b5 ">Example for ID column:</p>
                                <p style="font-size: 12px; color: #b5b5b5 ">=gt=0 and =ls=10</p>
                            </div>`;
}
    AgGridHelpToolTip.prototype.getGui = function () {
        return this.eGui;
    };

    export const helpHeaderTemplate =
        '<div class="ag-cell-label-container" role="presentation">' +
        '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
        '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
        '    <i style="color: orange; margin-right: 2px" class="fas fa-question-circle fa-lg ag-help-question-mark"></i> ' +
        '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
        '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
        '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
        '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
        '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
        '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
        '  </div>' +
        '</div>';



// WEBPACK FOOTER //
// ./app/components/bo-core/common/AgGridFilterHelpTooltip.ts